export class SearchModel {
    static DEFAULT_PAGE_SIZE: number = 10;
    static DEFAULT_PAGE_INDEX: number = 10;
    static CREATED_AT_FIELD: string = 'createdAt';
    static LAST_MODIFIED_AT_FIELD: string = 'lastModifiedAt';
    static ID_FIELD: string = 'id';
}

export class SearchOutDto<T> {
    data: T[];
    paginationOutDto?: PaginationOutDto;
    sortBy: string;
    direction: SORT_BY_DIRECTION;
    searchText: string;
    facets: FacetResult;
}

export class FacetResult {
    applicationStatusCounts?: FacetCount[];
    companyNameCounts?: FacetCount[];
    jobTitleCounts?: FacetCount[];
    hiringRoundCounts?: FacetCount[];
    skillCounts?: FacetCount[];
    skillGroupCounts?: FacetCount[];
    talentGroupCounts?: FacetCount[];
    questionAnswerCounts?: FacetGroup[];
    talentStatusCounts?: FacetCount[];
    tagCounts?: FacetCount[];
    talentGroupStatusCounts?: FacetCount[];
    talentGroupTypeCounts?: FacetCount[];
    statusCounts?: FacetCount[];
    talentAssessmentStatusCounts?: FacetCount[];
    talentAssessmentStatusCountsByAssessmentId?: FacetGroup[];
    assessmentDomainCounts?: FacetCount[];
    assessmentStatusCounts?: FacetCount[];
    assessmentAnswerTypeCounts?: FacetCount[];
    assessmentQuestionDifficultyLevelCounts?: FacetCount[];
    planExpiredCounts?: FacetCount[];
    assignedJobStatusCounts?: FacetCount[];
    assignedTalentApplicationStatusCounts?: FacetCount[];
    courseStatusCounts?: FacetCount[];
    courseVisibilityCounts?: FacetCount[];
    topicCounts?: FacetCount[];
    courseOwnershipCounts?: FacetCount[];
    competitionStatusFacetCounts?: FacetCount[];
    competitionEnrolmentStatusFacetCounts?: FacetCount[];
    competitionScoreStatusFacetCounts?: FacetCount[];
    enrolmentStatusCounts?: FacetCount[];
}

export class FacetCount {
    name: string;
    count: number;
}

export interface FacetGroup {
    name: string;
    type: string;
    facetCounts: FacetCount[];
}

export interface FacetGroupFilter {
    fieldName: string;
    values: string[];
    filterGroupDataType: FILTER_GROUP_DATA_TYPE;
    operator?: SEARCH_OPERATOR;
    groupIndex?: number;
    groupCondition?: SearchCondition;
    index?: number; //Note : Only for frontend
}

export interface FacetRangeFilter {
    fieldName: string;
    facetRange: {
        min: number;
        max: number;
    };
    filterDataType: FilterDataType;
}

export enum FilterDataType {
    STRING = 'STRING',
    NUMBER_RANGE = 'NUMBER_RANGE',
    DATE_RANGE = 'DATE_RANGE'
}

export enum FILTER_GROUP_DATA_TYPE {
    STRING = 'STRING',
    DATE_RANGE = 'DATE_RANGE',
    BOOLEAN = 'BOOLEAN',
    NUMBER = 'NUMBER',
    NUMBER_RANGE = 'NUMBER_RANGE',
}

export class DeprecatedSearchInDto {
    searchText?: string = "";
    pageIndex?: number = SearchModel.DEFAULT_PAGE_INDEX;
    pageSize?: number = SearchModel.DEFAULT_PAGE_SIZE;
    sortBy?: SORT_BY = SORT_BY.CREATED_AT;
    direction?: SORT_BY_DIRECTION;
    searchCriteriaDtos?: SearchCriteriaDto[];
    sortByFields?: SortField[];
}

export class SearchCriteriaInDto {
    condition?: SearchCondition = SearchCondition.AND;
    searchCriteriaDtos?: SearchCriteriaDto[];
    nestedSearchCriteria?: SearchCriteriaInDto[];
}

export class SearchInDto extends SearchCriteriaInDto {
    searchText?: string = "";
    pageIndex?: number = SearchModel.DEFAULT_PAGE_INDEX;
    pageSize?: number = SearchModel.DEFAULT_PAGE_SIZE;
    sortByFields?: SortField[];
    facetFields?: string[];
}

export enum SearchCondition {
    AND = 'AND',
    OR = 'OR'
}

export class SortField {
    sortBy?: SORT_BY = SORT_BY.LAST_MODIFIED_AT;
    direction?: SORT_BY_DIRECTION;
}

export class PaginationOutDto {
    pageIndex: number = 0;
    pageSize: number = 20;
    totalElements: number;
    totalPages: number;

    constructor(pageIndex: number, pageSize: number) {
        this.pageIndex = pageIndex;
        this.pageSize = pageSize;
    }
}

export class SearchCriteriaDto {
    public fieldName?: string;
    public value: Object;
    public operator: SEARCH_OPERATOR;
}

export enum SORT_BY {
    CREATED_AT = 'createdAt',
    LAST_MODIFIED_AT = 'lastModifiedAt',
    ARCHIVED_AT = 'archivedAt',
    ID = 'ID',
    RESUME_SCORE = 'resumeScore',
    ATTENDANCE__PRESENT = 'attendancePresent',
    ATTENDANCE__TOKEN = 'attendance.tokenNumber',
    ATTENDANCE__ATTENDED = 'attendance.attended',
    NAME = 'name',
    GROUP_TYPE = 'groupType',
    ALL_TALENTS = 'allTalents'
}

export enum FILTER_BY {
    RESUME__TOTAL_EXPERIENCE = "applicationHasResumes.totalExperience",
    RESUME__TOTAL_PROJECTS = "applicationHasResumes.totalProjects"
}

export enum SEARCH_OPERATOR {
    in = 'in',
    like = 'like',
    lt = 'lt',
    gt = 'gt',
    eq = 'eq',
    text_search = 'text_search',
    not_like = 'not_like',
    not_in = 'not_in',
    exists = 'exists',
    not_exists = 'not_exists',
    not_eq = 'not_eq',
    between = 'between',
    le = 'le',
    ge = 'ge',
    like_in = 'like_in',
    qa_match = 'qa_match'
}

export enum SORT_BY_DIRECTION {
    ASC = 'ASC',
    DESC = 'DESC'
}
